const slugify = (title) => {
  const umlautMap = {
    ä: "ae",
    ö: "oe",
    ü: "ue",
    Ä: "Ae",
    Ö: "Oe",
    Ü: "Ue",
    ß: "ss",
  };

  title = title.replace(/[äöüÄÖÜß]/g, (match) => umlautMap[match]);
  title = title.normalize("NFKD").replace(/[\u0300-\u036f]/g, "");
  title = title.toLowerCase();
  title = title.replace(/[^a-zA-Z0-9äöüÄÖÜß]/g, " ");
  title = title.replace(/\s+/g, " ");
  title = title.trim().replace(/ /g, "+");

  return title;
};

export default slugify;
